export const isAuth="isAuth"
export const isLog="isLog"
export const isBooked="isBooked"
export const setBooked="setBooked"